import { Menu, Modal, UnstyledButton } from '@mantine/core';
import { useState } from 'react';

import { Batch, BatchTypeEnum } from '@e-origin/shared';

import { actionsIcon, IconFactory } from '@assets';
import { GenerateBulkCustomsReportModal } from './GenerateBulkCustomsReportModal';

export interface BulkActionsMenuProps {
  selectedBatchIds: string[];
  batchesData: Batch[];
  batchView: BatchTypeEnum;
}

export const BulkActionsMenu: React.FC<BulkActionsMenuProps> = ({ selectedBatchIds, batchesData, batchView }) => {
  const [opened, setOpened] = useState(false);

  return (
    <>
      <Modal opened={opened} onClose={() => setOpened(false)} title="Bulk Customs Reports" centered>
        <GenerateBulkCustomsReportModal selectedBatchIds={selectedBatchIds} batchesData={batchesData} batchView={batchView} onClose={() => setOpened(false)} />
      </Modal>

      <Menu position="left-start">
        <Menu.Target>
          <UnstyledButton pr="xs">
            <img src={actionsIcon} alt="bulk actions" />
          </UnstyledButton>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item leftSection={<img src={IconFactory.report} alt="report" style={{ maxWidth: 22 }} />} onClick={() => setOpened(true)}>
            Generate Bulk Customs Reports
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </>
  );
};
